// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSun = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#sun_svg__a)"
    >
      <path d="M7.121 12a4.879 4.879 0 1 1 9.758 0 4.879 4.879 0 0 1-9.758 0zM12 1.269v1.95M12 20.78v1.951M4.41 4.41l1.37 1.37M18.206 18.206l1.371 1.371M3.22 12H1.268M20.78 12h1.951M4.41 19.59l1.37-1.37M19.578 4.423l-1.372 1.371" />
    </g>
    <defs>
      <clipPath id="sun_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSun;
